<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  mounted(){
    window.$.validator.methods.email = function( value, element ) {
      return this.optional( element ) || /^([a-zA-Z0-9]+(?:[.-]?[a-zA-Z0-9]+)@[a-zA-Z0-9]+(?:[.-]?[a-zA-Z0-9]+)\.[a-zA-Z]{2,7})$/.test( value );
    }
  }
}
</script>

<style lang="scss">
  body{
    background: #fff;
  }
  @import "assets/scss/main";
</style>
